"use client";

import { useSyncExternalStore } from "react";

type Language = "en" | "zh";

function subscribeToLanguage(onChange: () => void) {
  window.addEventListener("trypcell-language", onChange);
  return () => window.removeEventListener("trypcell-language", onChange);
}

function getLanguage(): Language {
  return document.body.dataset.language === "en" ? "en" : "zh";
}

function getServerLanguage(): Language {
  return "zh";
}

export function LanguageText({
  zh,
  en,
  as: Tag = "span",
  className,
}: {
  zh: string;
  en: string;
  as?:
    | "span"
    | "small"
    | "strong"
    | "p"
    | "div"
    | "h1"
    | "h2"
    | "h3"
    | "dd";
  className?: string;
}) {
  const language = useSyncExternalStore(
    subscribeToLanguage,
    getLanguage,
    getServerLanguage,
  );

  return <Tag className={className}>{language === "zh" ? zh : en}</Tag>;
}
